// removed by extract-text-webpack-plugin
module.exports = {"container":"_2kmG4a54keFOkBWXnr-hXW","title":"_2TJNPK2YUp1VPH4reYgBLi"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Root/ApolloError/styles.css
// module id = 1228
// module chunks = 83